import type { ApplicationSectionLink } from 'types/applicationSection';
import {
  getSclaAppBackgroundPath,
  getSclaAppFamilyPath,
  getSclaAppPromptsPath,
  getSclaAppRecPath,
  getSclaAppSchoolPath,
  getSclaAppSignaturePath,
  getSclaAppTranscriptsPath,
} from 'utils/navigation';
import type { SclaApplication } from '../types';
import { sclaPromptsComplete } from '../utils/sectionStatus';

export const SCLA_APPLICATION_SECTIONS = [
  {
    id: 'background',
    navTitle: 'Background',
    subtitle: 'About you',
    tabLabel: 'Background',
    checklistLabel: 'Background Info',
    to: getSclaAppBackgroundPath,
    getComplete: (app: SclaApplication) => app.backgroundInfo.sectionComplete,
  },
  {
    id: 'family',
    navTitle: 'Family',
    subtitle: 'Household',
    tabLabel: 'Family',
    checklistLabel: 'Family Info',
    to: getSclaAppFamilyPath,
    getComplete: (app: SclaApplication) => app.familyInfo.sectionComplete,
  },
  {
    id: 'school',
    navTitle: 'School',
    subtitle: 'School and interests',
    tabLabel: 'School',
    checklistLabel: 'School Info',
    to: getSclaAppSchoolPath,
    getComplete: (app: SclaApplication) => app.schoolInfo.sectionComplete,
  },
  {
    id: 'prompts',
    navTitle: 'Prompts',
    subtitle: 'Short responses',
    tabLabel: 'Prompts',
    checklistLabel: 'Short Response Prompts',
    to: getSclaAppPromptsPath,
    getComplete: (app: SclaApplication) => sclaPromptsComplete(app),
  },
  {
    id: 'transcripts',
    navTitle: 'Transcripts',
    subtitle: 'Upload grades',
    tabLabel: 'Transcripts',
    checklistLabel: 'Transcripts',
    to: getSclaAppTranscriptsPath,
    getComplete: (app: SclaApplication) => app.transcriptsInfo.sectionComplete,
  },
  {
    id: 'rec',
    navTitle: 'Letter of rec',
    subtitle: 'Optional',
    tabLabel: 'Letter of Rec',
    checklistLabel: 'Letter of Recommendation (Optional)',
    to: getSclaAppRecPath,
    getComplete: (app: SclaApplication) => app.recInfo.sectionComplete,
  },
  {
    id: 'signature',
    navTitle: 'Sign & submit',
    subtitle: 'Review and sign',
    tabLabel: 'Submit',
    checklistLabel: 'Submit Application',
    to: getSclaAppSignaturePath,
    getComplete: (app: SclaApplication) => app.signatureInfo.sectionComplete,
  },
] as const;

export function buildSclaApplicationSections(
  application: SclaApplication,
): ApplicationSectionLink[] {
  return SCLA_APPLICATION_SECTIONS.map(section => ({
    label: section.tabLabel,
    to: section.to(),
    complete: section.getComplete(application),
  }));
}
